<template>
  <div class="box-search">
    <SearchSelect
      v-if="mode === 'single'"
      :value="props.boxCode"
      :placeholder="placeholder || $lang('请输入')"
      :field-names="fieldNames"
      :params="params"
      :ajax-url="ajaxUrl"
      :is-join="isJoin"
      @update:value="(val) => emit('update:boxCode', val)"
    />
    <BillCodesToArray v-else :value="boxCodes" :pattern="/^[A-Z0-9]+$/" :placeholder="placeholder || $lang('请输入快递柜编码,多编号使用逗号、空格或回车键隔开,最多100个')" @update:value="(val) => emit('update:boxCodes', val)" />
  </div>
</template>
<script lang="ts" setup name="BoxSearch">
  import { ref, watch } from 'vue'
  import SearchSelect from '../searchSelect/Index.vue'
  import BillCodesToArray from './BillCodesToArray.vue'

  type Mode = 'single' | 'multiple'

  const props = withDefaults(
    defineProps<{
      mode?: Mode
      boxCode?: string
      boxCodes?: string[]
      ajaxUrl?: any
      params?: string
      fieldNames?: { label: string; value: string }
      isJoin?: boolean
      placeholder?: string
    }>(),
    {
      mode: 'single',
      boxCode: '',
      boxCodes: () => [],
      params: 'box',
      fieldNames: () => ({ label: 'name', value: 'code' }),
      isJoin: true,
      placeholder: ''
    }
  )

  const emit = defineEmits(['update:boxCode', 'update:boxCodes'])

  const boxCodes = ref<string[]>([...props.boxCodes])

  watch(
    () => props.boxCodes,
    (c) => {
      boxCodes.value = [...c]
    }
  )

  // 切换模式时清空另一字段，保证只提交一个字段
  watch(
    () => props.mode,
    (cur, prev) => {
      if (cur === prev) return
      if (cur === 'single') {
        emit('update:boxCodes', [])
      } else {
        emit('update:boxCode', '')
      }
    }
  )
</script>